import { useEffect } from 'react'
import { get } from '../api/api'
import { useAppStore } from '../store/appStore'
import { OrganizationModel } from '../models/OrganizationModel'
import { isReadOnly } from '../models/UserModel'

export const useOrgInit = () => {
    const userModel = useAppStore((state) => state.userModel)

    useEffect(() => {
        const fetchOrgModel = async () => {
            if (!userModel?.org_id || isReadOnly(userModel)) return

            try {
                const orgModel = await get<OrganizationModel>('/organization')
                useAppStore.setState({ orgModel })
            } catch (error) {
                console.warn('Failed to fetch organization info:', error)
            }
        }
        fetchOrgModel()
    }, [userModel])
}
